var React = require('react');

function PlusCircleAlt (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"currentColor","key":0}),React.createElement("rect",{"x":"14.0586","y":"7.5","width":"1.88235","height":"16","fill":"white","key":1}),React.createElement("rect",{"x":"7","y":"14.5586","width":"16","height":"1.88235","fill":"white","key":2})]);
}

PlusCircleAlt.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = PlusCircleAlt;

PlusCircleAlt.default = PlusCircleAlt;
